import http from '@/http';

export default class TicketService {
  static async getUrl() {
    return http.get(`/tickets/url`).then((response) => response.data);
  }
}
